import OrbitApiOps from './OrbitApi'

class RewardsAPI {
  static getAllPromocodesForOneUser({ userId, faberToken }: PromocodeProps) {
    return OrbitApiOps.httpGet(
      `reward/ops/wallet/promocode/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static getCampaignPromocodes(
    code,
    limit,
    offset,
    sort,
    faberToken: PromocodeProps
  ) {
    return OrbitApiOps.httpGet(
      `/reward/ops/promocode/campaign?code=${code}&limit=${limit}&offset=${offset}&orderBy=${sort}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static getDistributorPromocodes(
    code,
    limit,
    offset,
    sort,
    faberToken: PromocodeProps
  ) {
    return OrbitApiOps.httpGet(
      `/reward/ops/promocode/distributor?code=${code}&limit=${limit}&offset=${offset}&orderBy=${sort}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static getReferralPromocodes(
    code,
    limit,
    offset,
    sort,
    faberToken: PromocodeProps
  ) {
    return OrbitApiOps.httpGet(
      `/reward/ops/promocode/referral?code=${code}&limit=${limit}&offset=${offset}&orderBy=${sort}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static createPromoCode(body: PromoCodeModel) {
    return OrbitApiOps.httpPost(
      `/reward/ops/promocode`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getRewardProducts(faberToken: string) {
    return OrbitApiOps.httpGet(
      `/reward/ops/product`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }

  static createRewardProduct(body: RewardProductModel) {
    return OrbitApiOps.httpPost(
      `/reward/ops/product/create`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getBenefits(faberToken: string) {
    return OrbitApiOps.httpGet(
      `/reward/ops/benefit`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }

  static createBenefit(body: BenefitModel) {
    return OrbitApiOps.httpPost(
      `/reward/ops/benefit/create`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getCatalogs(faberToken: string) {
    return OrbitApiOps.httpGet(
      `/catalog/ops/item`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.body.data
    })
  }

  static createDistributor(body: DistributorModel) {
    return OrbitApiOps.httpPost(
      `/reward/ops/distributor`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getDistributors(faberToken: string) {
    return OrbitApiOps.httpGet(
      `/reward/ops/distributor`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }

  static createDistributorPromo(body: DistributorPromoModel) {
    return OrbitApiOps.httpPost(
      `/reward/ops/promocode/distributor`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }
}

export default RewardsAPI

interface PromocodeProps {
  userId: string
  faberToken: string
  code?: string
  limit?: number
  offset?: number
  sort?: string
}

interface PromoCodeModel {
  campaignRewardName: string
  campaignSummary: string
  campaignCode: string
  campaignCodePrefix?: string
  rewardProductId: string
  maxClaims: number
  maxConsumption: number
  validityStartAt: number
  validityEndAt: number
  faberToken: string
}

interface RewardProductModel {
  rewardName: string
  rewardDescription: string
  rewardDescriptionInternal: string
  benefitTypeId: string[]
  rewardRuleId: string[]
  faberToken: string
}

interface BenefitModel {
  benefitSummary: string
  benefitCategory: string
  benefitProductID: string
  benefitValue: string
  benefitUnit: string
  faberToken: string
}

interface DistributorModel {
  distributorName: string
  faberToken: string
}

interface DistributorPromoModel {
  distributorId: string
  promocodeSummary: string
  rewardProductId: string
  maxClaims: number
  maxConsumption: number
  validityStartAt: number
  validityEndAt: number
  batchSize: number
  faberToken: string
}
